import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { getColor } from '../../tux-h5-color/dist/es/getColor.js';
import { TUXNavBar } from '../TUXNavBar/TUXNavBar.js';
import { useTUXContext } from '../TUXProvider/TUXProvider.js';

var _excluded = ["hasPlaceholder", "backgroundColor", "backgroundOpacity"];
var TUXAppBar = function TUXAppBar(_ref) {
  var _ref$hasPlaceholder = _ref.hasPlaceholder,
      hasPlaceholder = _ref$hasPlaceholder === void 0 ? true : _ref$hasPlaceholder,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'BGPrimary' : _ref$backgroundColor,
      backgroundOpacity = _ref.backgroundOpacity,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTUXContext = useTUXContext(),
      platform = _useTUXContext.platform,
      hasStatusBar = _useTUXContext.hasStatusBar,
      theme = _useTUXContext.theme,
      androidStatusBarHeight = _useTUXContext.androidStatusBarHeight,
      navBarHeight = _useTUXContext.navBarHeight;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      backgroundColorVal = _useState2[0],
      setBackgroundColorVal = _useState2[1];

  useEffect(function () {
    if (theme) {
      setBackgroundColorVal(getColor(backgroundColor, theme).rgba);
    }
  }, [theme, backgroundColor]);
  var navbar = /*#__PURE__*/React.createElement(TUXNavBar, _extends({}, props, {
    backgroundColor: backgroundColor,
    backgroundOpacity: backgroundOpacity,
    center: props.center || props.title
  }));
  var WithStatusBarClass = hasStatusBar ? 'TUXAppBar--with-ios-status-bar--legacy TUXAppBar--with-ios-status-bar--iOS11 TUXAppBar--with-ios-status-bar' : "";

  if (platform === 'iOS') {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: clsx('fixed top-0 left-0 right-0 z-1000', WithStatusBarClass)
    }, /*#__PURE__*/React.createElement("div", {
      role: "none",
      className: "absolute w-full h-full top-0 left-0 -z-1",
      style: {
        backgroundColor: backgroundColorVal,
        opacity: backgroundOpacity
      }
    }), navbar), hasPlaceholder && /*#__PURE__*/React.createElement("div", {
      role: "none",
      className: WithStatusBarClass,
      style: {
        paddingBottom: navBarHeight
      }
    }));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed top-0 left-0 right-0 z-1000",
    style: {
      paddingTop: hasStatusBar ? androidStatusBarHeight : 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    role: "none",
    className: "absolute w-full h-full top-0 left-0 -z-1",
    style: {
      backgroundColor: backgroundColorVal,
      opacity: backgroundOpacity
    }
  }), navbar), hasPlaceholder && /*#__PURE__*/React.createElement("div", {
    role: "none",
    className: "flex-shrink-0",
    style: {
      paddingTop: hasStatusBar ? androidStatusBarHeight : 0,
      paddingBottom: navBarHeight
    }
  }));
};

export { TUXAppBar };
//# sourceMappingURL=TUXAppBar.js.map
